import InitAdminNotificationsLogic from "./AdminNotifications.logic";

const AdminNotificationsComponent: React.FC = () => {
    const {
        settings, loading, saving, sending,
        pushTitle, pushMessage, setPushTitle, setPushMessage,
        setField, onSave, onSendPush,
    } = InitAdminNotificationsLogic();

    if (loading) {
        return (
            <div className="page-container">
                <h1 className="text-align-center">Obaveštenja</h1>
                <p style={{ textAlign: "center", opacity: 0.6 }}>Učitavanje...</p>
            </div>
        );
    }

    return (
        <div className="page-container">
            <h1 className="text-align-center">Obaveštenja</h1>

            {/* --- Baner na vrhu --- */}
            <div className="card" style={{ marginTop: 16 }}>
                <h3 style={{ marginTop: 0 }}>Baner na vrhu</h3>
                <p style={{ opacity: 0.7, fontSize: "0.9rem", marginTop: -6 }}>
                    Kad je aktivan, prikazuje se klijentima umesto upitnika.
                </p>

                <label style={{ display: "flex", alignItems: "center", gap: 8, margin: "8px 0" }}>
                    <input type="checkbox" style={{ width: "auto" }}
                        checked={!!settings.bannerActive}
                        onChange={(e) => setField("bannerActive", e.target.checked)} />
                    Aktivan
                </label>

                <label htmlFor="bannerMessage">Poruka</label>
                <textarea id="bannerMessage" rows={3} value={settings.bannerMessage || ""}
                    placeholder="npr. Srećna Nova godina! Radimo od 5. januara."
                    onChange={(e) => setField("bannerMessage", e.target.value)} />

                <div style={{ display: "flex", gap: 16, marginTop: 8, flexWrap: "wrap" }}>
                    <div>
                        <label htmlFor="bg">Boja pozadine</label>
                        <input id="bg" type="color" style={{ width: 48, height: 34, padding: 0 }}
                            value={settings.bannerBgColor || "#d4f0d4"}
                            onChange={(e) => setField("bannerBgColor", e.target.value)} />
                    </div>
                    <div>
                        <label htmlFor="fg">Boja teksta</label>
                        <input id="fg" type="color" style={{ width: 48, height: 34, padding: 0 }}
                            value={settings.bannerTextColor || "#2d862d"}
                            onChange={(e) => setField("bannerTextColor", e.target.value)} />
                    </div>
                </div>

                {/* Pregled */}
                <p style={{ opacity: 0.7, fontSize: "0.85rem", margin: "12px 0 4px" }}>Pregled:</p>
                <div style={{
                    background: settings.bannerBgColor || "#d4f0d4",
                    color: settings.bannerTextColor || "#2d862d",
                    borderRadius: 10, padding: "12px 14px", fontWeight: 600,
                    textAlign: "center", whiteSpace: "pre-wrap",
                }}>
                    {settings.bannerMessage?.trim() ? settings.bannerMessage : "Primer poruke"}
                </div>
            </div>

            {/* --- Upitnik --- */}
            <div className="card" style={{ marginTop: 12 }}>
                <h3 style={{ marginTop: 0 }}>Upitnik</h3>
                <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <input type="checkbox" style={{ width: "auto" }}
                        checked={settings.surveyEnabled !== false}
                        onChange={(e) => setField("surveyEnabled", e.target.checked)} />
                    Prikaži upitnik klijentima
                </label>
                <p style={{ opacity: 0.7, fontSize: "0.85rem", marginTop: 6 }}>
                    Ako je baner aktivan, upitnik se ionako ne prikazuje.
                </p>
            </div>

            <button className="btn-primary" type="button" onClick={onSave} disabled={saving} style={{ marginTop: 12 }}>
                {saving ? "Čuvanje..." : "Sačuvaj podešavanja"}
            </button>

            {/* --- Push svima --- */}
            <div className="card" style={{ marginTop: 20 }}>
                <h3 style={{ marginTop: 0 }}>Push obaveštenje svim klijentima</h3>
                <p style={{ opacity: 0.7, fontSize: "0.9rem", marginTop: -6 }}>
                    Šalje se samo klijentima koji imaju uključene notifikacije.
                </p>

                <label htmlFor="pushTitle">Naslov</label>
                <input id="pushTitle" type="text" value={pushTitle}
                    placeholder="npr. Reset Pilates"
                    onChange={(e) => setPushTitle(e.target.value)} />

                <label htmlFor="pushMessage">Poruka</label>
                <textarea id="pushMessage" rows={3} value={pushMessage}
                    placeholder="npr. Sutra ne radimo, vidimo se u ponedeljak!"
                    onChange={(e) => setPushMessage(e.target.value)} />

                <button className="btn-primary" type="button" onClick={onSendPush} disabled={sending} style={{ marginTop: 12 }}>
                    {sending ? "Slanje..." : "Pošalji svima"}
                </button>
            </div>
        </div>
    );
}

export default AdminNotificationsComponent;
